import React, { useMemo/* , useState */ } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import AddOns from "./AddOns";
import AIbasedContent from "./AIbasedContent";
import AIBasedFeeCollection from "./AIBasedFeeCollection";
import AIBasedFestival from "./AIBasedFestival";
import AIBasedParental from "./AIBasedParental";
import AIBasedStudent from "./AIBasedStudent";
import AIChildCare from "./AIChildCare";
import AILearning from "./AILearning";
import AIReelGenration from "./AIReelGenration";
import Blog from "./Blogs";
import ForStartups from "./ForStartups";
import HeroSection from "./HeroSection";
import InNews from "./InNews";
import SchoolMarketing from "./SchoolMarketing";
import NewHeroSection from "./NewHeroSection";
import ParticlesBackground from 'components/new-landing-page/ParticlesBackground';
import DigitalMarketing from './NewHeroSection/AvatarDigitalMarketer/DegitalMarketing';
import AiMarketingTeam from './NewHeroSection/AvatarDigitalMarketer/AiMarketingTeam';
import PartnershipSection from './NewHeroSection/AvatarDigitalMarketer/PatnershipSection';
import WhatWeDeliver from './NewHeroSection/AvatarDigitalMarketer/WhatWeDeliver';
import StoryOfEveryIndianEdu from './NewHeroSection/AvatarDigitalMarketer/StoryOfEveryIndianEdu';
import { FAQSection } from './NewHeroSection/AvatarDigitalMarketer/FAQSection';
import Teacher from './NewHeroSection/AvatarTeacher/Teacher';
import SoulOfTeaching from './NewHeroSection/AvatarTeacher/SoulOfTeaching';
import WhySchoolOwnersTrust from './NewHeroSection/AvatarTeacher/WhySchoolOwnersTrust';
import MeetYourAiTeachingTeam from './NewHeroSection/AvatarTeacher/MeetYourAiTeachingTeam';
import Mindset from './NewHeroSection/AvatarTeacher/Mindset';
import Support from './NewHeroSection/AvatarSupport/Support';
import ProblemSchoolFaces from './NewHeroSection/AvatarSupport/ProblemSchoolFaces';
import EverthingYourSchoolNeed from './NewHeroSection/AvatarSupport/EverthingYourSchoolNeed';
import AiPoweredChat from './NewHeroSection/AvatarSupport/AiPoweredChat';
import WhySchoolLoveUs from './NewHeroSection/AvatarSupport/WhySchoolLoveUs';
import Operator from './NewHeroSection/AvatarOperator/Operator';
import FromChaos from './NewHeroSection/AvatarOperator/FromChaos';
import EverythingYourSchoolNeedOperator from './NewHeroSection/AvatarOperator/EverythingYourSchoolNeedOperator';
import AutoConnect from './NewHeroSection/AvatarOperator/AutoConnect';
import AiExpert from './NewHeroSection/AvatarOperator/AiExpert';

// import Startup from './NewHeroSection/AvatarStrartup/Startup';
// import EachDepartment from './NewHeroSection/AvatarStrartup/EachDepartment';
// import GrowFaster from './NewHeroSection/AvatarStrartup/GrowFaster';
// import KeyHighlights from './NewHeroSection/AvatarStrartup/KeyHighlights';
// import AiExpertDirectBenifits from './NewHeroSection/AvatarStrartup/AiExpertDirectBenifits';

// import Whatsapp from './NewHeroSection/AvatarWhatsapp/Whatsapp';
// import Keyfeatures from './NewHeroSection/AvatarWhatsapp/Keyfeatures';
// import HowItWorks from './NewHeroSection/AvatarWhatsapp/HowItWorks';
// import AiExpertTutor from './NewHeroSection/AvatarWhatsapp/AiExterTutor';
// import WhySchoolLoveAiPowred from './NewHeroSection/AvatarWhatsapp/WhySchoolLoveAiPowred';

// import IdCard from './NewHeroSection/AvatarIDCards/IdCard';
// import IdCardHowItWorks from './NewHeroSection/AvatarIDCards/HowItWorks';
// import WhySchoolLoveAiPowredIdCard from './NewHeroSection/AvatarIDCards/WhySchoolLoveAiPowredIdCard';

import WhatYouWillLearn from './NewHeroSection/AvatarWebinar/WhatYouWillLearn';
import WhyYouShouldAttend from './NewHeroSection/AvatarWebinar/WhyYouShouldAttend';
import WhoShouldAttend from './NewHeroSection/AvatarWebinar/WhoShouldAttend';
import Footer from './NewHeroSection/AvatarWebinar/Footer';
import LandingPageComponentWrapper from './NewHeroSection/components/LandingPageComponentWrapper';
import EndingSection from './NewHeroSection/AvatarDigitalMarketer/EndingSection';
import Text from './NewHeroSection/components/Text';
// import Input from './NewHeroSection/components/Input';
// import Button from './NewHeroSection/components/Button';
import Webinar from './NewHeroSection/AvatarWebinar/Webinar';
// import { CheckboxList } from './NewHeroSection/AvatarStrartup';
// import Input from './NewHeroSection/components/Input';
// import Button from './NewHeroSection/components/Button';
// import AboutUs from './NewHeroSection/AboutUs';
// import ContactUs from './NewHeroSection/ContactUs';

const faqItemsForDigitalMarketer = [
  {
    id: 1,
    question: "Is it really free for the first year?",
    answer:
      "Yes. We grant selected schools access worth up to ₹5,00,000 for 12 months to help them prove impact without risk.",
  },
  {
    id: 2,
    question: "Do we need a marketing team?",
    answer:
      "No. Your AI employees handle website, SEO, social, reels and admissions follow-ups automatically.",
  },
  {
    id: 3,
    question: "Can we use our brand colours and logo?",
    answer:
      "Absolutely. Everything is customised to your school’s identity, tone and values.",
  },
  {
    id: 4,
    question: "How fast can we go live?",
    answer:
      "Most schools launch in under 10 minutes once basic details are provided.",
  },
  {
    id: 5,
    question: "What happens after the first year?",
    answer:
      "You can continue with flexible plans or export your assets. We believe in partnership, not lock-ins.",
  },
];

const faqItemsForTeacher = [
  {
    id: 1,
    question: "Does SooMuch.ai replace teachers?",
    answer:
      "Never. It reinforces the teacher's mission by preparing students emotionally so classroom time is more effective.",
  },
  {
    id: 2,
    question: "How fast can we launch?",
    answer:
      "Full setup typically finishes in under 10 minutes. Your morning mindset routine can begin the very next day.",
  },
  {
    id: 3,
    question: "Is it affordable for all schools?",
    answer:
      "We contribute ₹5 lakh worth of AI teaching tools free for the first year and onboard only 0.1% of schools per state for quality.",
  },
  {
    id: 4,
    question: "How do parents engage?",
    answer:
      "Multilingual voice, WhatsApp, and SMS keep every parent informed daily — no app learning curve required.",
  },
  {
    id: 5,
    question: "What measurable results can we expect?",
    answer:
      "Schools report calmer mornings, reduced exam anxiety, improved attention, and steady lifts in outcomes and admissions trust.",
  },
];

const faqItemsForSupport = [
  {
    id: 1,
    question: "What does AI-Powered Support mean for my school?",
    answer:
      "It means your school gets a 24×7 smart helper that monitors, fixes, and supports your systems automatically — just like a self-healing engine. It keeps your school running smoothly without stress, delays, or tech problems.",
  },
  {
    id: 2,
    question: "How does SooMuch.ai fix issues automatically?",
    answer:
      "Our AI scans your systems all day and night. When it detects a problem — like login errors, missing data, or system slowdowns — it repairs them by itself before anyone even notices. No waiting, no support tickets, no calls.",
  },
  {
    id: 3,
    question: "Do I need a technical team to set it up?",
    answer:
      "No! Setup takes less than 10 minutes. Just upload your school logo and photos — and the system goes live. If you ever need help, your Virtual Relationship Manager is available to guide you anytime.",
  },
  {
    id: 4,
    question: "What are the main benefits of AI-Powered Support?",
    answer: <div className='space-y-1'>
      <Text label={"✔ Predicts and fixes issues automatically"} type="description" />
      <Text label={"✔ Keeps your school’s apps, data, and reports working 24x7"} type="description" />
      <Text label={"✔ Saves time, reduces costs, and improves trust"} type="description" />
      <Text label={"✔ Frees your staff from daily tech follow-ups"} type="description" />
      <Text label={"✔ Builds calm, reliable school operations"} type="description" />
    </div>,
  },
  {
    id: 5,
    question: "Is there a free plan or offer available?",
    answer:
      "Yes! We are offering ₹5 lakh worth of AI services free for one year to only 0.1% of schools per state. This is not a trial — it’s our way of thanking schools and helping you experience truly stress-free operations.",
  },
];

const faqItemsForOperator = [
  {
    id: 1,
    question: "What does AI-Powered Operations mean for my school?",
    answer:
      "It means your school can run automatically with the help of AI. Attendance, fees, homework, reports, and parent messages are all managed by AI — saving you time, effort, and money every day.",
  },
  {
    id: 2,
    question: "How much can my school really save with SooMuch.ai?",
    answer:
      "On average, schools save up to ₹25 lakhs every year in business losses and 4400 manual hours by reducing manual work, missed fee collections, and outdated systems. AI automation helps you run smarter and avoid business losses.",
  },
  {
    id: 3,
    question: "How does SooMuch.ai help with parent communication?",
    answer:
      "Our AI talks to parents in 10+ Indian languages through WhatsApp, IVR, and app alerts. It makes sure every message is delivered and understood — building trust and stronger relationships.",
  },
  {
    id: 4,
    question: "What kind of tasks can AI handle for teachers?",
    answer:
      "AI manages attendance, homework reminders, fee follow-ups, parent feedback, and reports automatically. Teachers can focus on teaching while AI handles all the routine work.",
  },
  {
    id: 5,
    question: "Is there any cost to start using SooMuch.ai?",
    answer:
      "We’re giving ₹5 lakh worth of AI services completely free for the first year — for only 0.1% of schools in each state. You can book a free demo to see how it works before you decide.",
  },
];

// const faqItemsForStartups = [
//   {
//     id: 1,
//     question: "What is AI For Startups?",
//     answer:
//       "It’s a complete system that runs your school — from marketing and teaching to fee collection and legal work. You get full-time AI employees who work automatically for your school.",
//   },
//   {
//     id: 2,
//     question: "How will it help me start or grow my school?",
//     answer:
//       "It handles everything: Marketing and admissions (AI Marketing Team), Teaching and motivation (AI Teaching Team), Fees, communication, and parent reports (AI Operations Team), and Issue solving and support (AI Support Team). Everything works together to save money, save time, and grow your school faster.",
//   },
//   {
//     id: 3,
//     question: "I’m not a technical person — can I still use it?",
//     answer:
//       "Yes! You don’t need any computer skills. It is completely automated. Upload your logo and photos — your school’s AI system goes live in under 10 minutes.",
//   },
//   {
//     id: 4,
//     question: "How does it help in marketing?",
//     answer:
//       "Your AI Marketing Team builds your website, runs social media, creates reels, and manages admissions automatically. You also get all print materials — brochures, banners, and leaflets — ready to use.",
//   },
//   {
//     id: 5,
//     question: "Can it help me with accounts and legal setup?",
//     answer:
//       "Yes! The AI Startup Suite gives you CS, CA, and legal support — for company registration, accounts, and permissions. Everything is organised and guided by experts.",
//   },
//   {
//     id: 6,
//     question: "How much does it cost to start?",
//     answer:
//       "You get ₹5 lakh worth of AI services free. We are onboarding only 0.1% schools per state — early members get lifetime benefits.",
//   },
//   {
//     id: 7,
//     question: "When will I see results?",
//     answer:
//       "Within a few days of setup — your website goes live, marketing starts, and parents begin engaging instantly.",
//   },
//   {
//     id: 8,
//     question: "Can this system double my admissions?",
//     answer:
//       "Yes! AI helps you reach more parents, reply faster, and convert leads easily — many schools have already doubled their admissions using SooMuch.ai.",
//   },
//   {
//     id: 9,
//     question: "What makes SooMuch.ai different?",
//     answer:
//       "Other software just gives you tools. SooMuch.ai gives you AI Employees who actually work for you: a Marketing Manager who runs your campaigns, a Teaching Coach who inspires students, an Operations Officer who manages daily work, and a Support Executive who keeps everything running. It’s not just software — it’s your full AI team.",
//   },
//   {
//     id: 10,
//     question: "How can I see it in action?",
//     answer:
//       "Join our free live webinar and see your school come alive with AI in real time. Setup takes less than 10 minutes. Only 0.1% of schools per state can join!",
//   },
// ];

// const faqItemsForWhatsapp = [
//   {
//     id: 1,
//     question: "Do parents need a new app?",
//     answer: "",
//   },
//   {
//     id: 2,
//     question: "How will it help me start or grow my school?",
//     answer: "",
//   }
// ];

// const faqItemsForIdCards = [
//   {
//     id: 1,
//     question: "Do we need new photos?",
//     answer:
//       "No. Use old photos — AI will enhance them. New photos also work great.",
//   },
//   {
//     id: 2,
//     question: "Can the QR do both attendance and payments?",
//     answer:
//       "Yes. One QR code can be used for both scanning to mark attendance and for fee payments.",
//   }
// ];

export const renderComponents = [
  // Digital Marketer
  { component: <DigitalMarketing />, bgColor: "", id: "digital-marketer-DigitalMarketing" },
  { component: <StoryOfEveryIndianEdu />, bgColor: "", id: "digital-marketer-StoryOfEveryIndianEdu" },
  { component: <AiMarketingTeam />, bgColor: "bg-[#ECECF7]", id: "digital-marketer-AiMarketingTeam" },
  { component: <PartnershipSection />, bgColor: "", id: "digital-marketer-PartnershipSection" },
  { component: <WhatWeDeliver />, bgColor: "bg-[#ECECF7]", id: "digital-marketer-WhatWeDeliver" },
  {
    component: (
      <EndingSection
        badge={"JOIN US TODAY"}
        title={"Exclusive Invitation"}
        desc={"Only 0.1% of schools per state are onboarded. Includes ₹5 lakh worth of free AI tools. Reach up to 1,00,000 parents. Grow admissions by up to ₹2.5 crores."}
        grdBtn={"Book Live Demo"}
        outBtn={"Claim Free AI Marketing Setup"}
        avatar={"/images/new-landing-page/digitalMarketerPersonV2.png"}
        frame={"/images/new-landing-page/digitalMarketerBoardV2.png"}
      />
    ),
    bgColor: "",
    id: "digital-marketer-EndingSection"
  },
  { component: <FAQSection faqItems={faqItemsForDigitalMarketer} />, bgColor: "", id: "digital-marketer-FAQSection", isFlex1: true },

  // Teacher
  { component: <Teacher />, bgColor: "", id: "teacher-Teacher" },
  { component: <SoulOfTeaching />, bgColor: "", id: "teacher-SoulOfTeaching" },
  { component: <MeetYourAiTeachingTeam />, bgColor: "bg-[#ECECF7]", id: "teacher-MeetYourAiTeachingTeam" },
  { component: <Mindset />, bgColor: "", id: "teacher-Mindset" },
  { component: <WhySchoolOwnersTrust />, bgColor: "bg-[#ECECF7]", id: "teacher-WhySchoolOwnersTrust" },
  {
    component: (
      <EndingSection
        badge={"JOIN US TODAY"}
        title={"Because when minds awaken, nations rise."}
        desc={"Book a live demo and see how AI teachers work every day - quietly, kindly, and effectively."}
        grdBtn={"Book Live Demo"}
        outBtn={"Claim ₹5L Free"}
        avatar={"/images/new-landing-page/teacherPersonV2.png"}
        avatarBoxClass={"-right-20"}
        avatarClassName={"max-w-md"}
        frame={"/images/new-landing-page/teacherBoardV2.png"}
      />
    ),
    bgColor: "",
    id: "teacher-EndingSection"
  },
  { component: <FAQSection faqItems={faqItemsForTeacher} />, bgColor: "", id: "teacher-FAQSection", isFlex1: true },

  // Support
  { component: <Support />, bgColor: "bg-[#ECECF7]", id: "support-Support" },
  { component: <ProblemSchoolFaces />, bgColor: "", id: "support-ProblemSchoolFaces" },
  { component: <EverthingYourSchoolNeed />, bgColor: "bg-[#ECECF7]", id: "support-EverthingYourSchoolNeed" },
  { component: <AiPoweredChat />, bgColor: "", id: "support-AiPoweredChat" },
  { component: <WhySchoolLoveUs />, bgColor: "bg-[#ECECF7]", id: "support-WhySchoolLoveUs" },
  {
    component: (
      <EndingSection
        badge={"JOIN US TODAY"}
        title={"Special Gift For Schools"}
        desc={"₹5 lakh worth of AI services FREE for 1 year. Limited to 0.1% of schools per state."}
        grdBtn={"Book Live Demo"}
        outBtn={"Claim ₹5L Free"}
        avatar={"/images/new-landing-page/supportPersonV2.png"}
        avatarBoxClass={"-right-20"}
        avatarClassName={"max-w-md"}
        frame={"/images/new-landing-page/supportBoardV2.png"}
      />
    ),
    bgColor: "",
    id: "support-EndingSection"
  },
  { component: <FAQSection faqItems={faqItemsForSupport} />, bgColor: "", id: "support-FAQSection", isFlex1: true },

  // Operator
  { component: <Operator />, bgColor: "bg-[#ECECF7]", id: "operator-Operator" },
  { component: <FromChaos />, bgColor: "", id: "operator-FromChaos" },
  { component: <EverythingYourSchoolNeedOperator />, bgColor: "bg-[#ECECF7]", id: "operator-EverythingYourSchoolNeedOperator" },
  { component: <AutoConnect />, bgColor: "", id: "operator-AutoConnect" },
  { component: <AiExpert />, bgColor: "bg-[#ECECF7]", id: "operator-AiExpert" },
  {
    component: (
      <EndingSection
        badge={"JOIN US TODAY"}
        title={"The SooMuch.AI Transformation"}
        desc={"Your teachers feel lighter. Your parents feel closer. Your classrooms feel calmer. Your school finally runs the way it was always meant to."}
        grdBtn={"Book Live Demo"}
        outBtn={"Claim ₹5L Free"}
        avatar={"/images/new-landing-page/operatorPersonV2.png"}
        avatarBoxClass={"-right-20"}
        avatarClassName={"max-w-md"}
        frame={"/images/new-landing-page/operatorBoardV2.png"}
      />
    ),
    bgColor: "",
    id: "operator-EndingSection"
  },
  { component: <FAQSection faqItems={faqItemsForOperator} />, bgColor: "", id: "operator-FAQSection", isFlex1: true },

  // AI For Startups
  // { component: <Startup />, bgColor: "bg-[#ECECF7]", id: "startup-Startup" },
  // { component: <EachDepartment />, bgColor: "", id: "startup-EachDepartment" },
  // { component: <GrowFaster />, bgColor: "bg-[#ECECF7]", id: "startup-GrowFaster" },
  // { component: <KeyHighlights />, bgColor: "", id: "startup-KeyHighlights" },
  // { component: <AiExpertDirectBenifits />, bgColor: "bg-[#ECECF7]", id: "startup-AiExpertDirectBenifits" },
  // {
  //   component: (
  //     <EndingSection
  //       badge={"READY TO LAUNCH?"}
  //       title={"Start strong, grow fast, and stay ahead forever."}
  //       desc={"Your teachers feel lighter. Your parents feel closer. Your classrooms feel calmer. Your school finally runs the way it was always meant to."}
  //       grdBtn={"Activate AI for Startups"}
  //       outBtn={"Join Live Demo"}
  //       avatar={"/images/new-landing-page/startupPersonV2.png"}
  //       avatarBoxClass={"-right-20"}
  //       avatarClassName={"max-w-sm"}
  //       customFrame={
  //         <div className="grid grid-cols-2 md:grid-cols-1 items-center bg-[#4949DE] rounded-3xl py-12 px-20 md:px-4 md:gap-8">
  //           <div className="space-y-4 mr-44 md:mr-0">
  //             <h2 className="text-[white] text-2xl max-w-xs font-semibold" style={{ fontFamily: 'Instrument Sans, sans-serif' }}>
  //               What are your requirements as a school startup?
  //             </h2>
  //             <CheckboxList />
  //           </div>
  //           <div className="space-y-10 bg-[white] rounded-3xl shadow-2xl p-8 ml-20 md:ml-0">
  //             <div className="space-y-4">
  //               <Input label="School Name" />
  //               <Input label="Full Name" />
  //               <Input label="Email/Phone" />
  //             </div>
  //             <div>
  //               <Button label="Get My School Startup Plan" type="gradient" cName="w-full" />
  //             </div>
  //           </div>
  //         </div>
  //       }
  //     />
  //   ),
  //   bgColor: "",
  //   id: "startup-EndingSection"
  // },
  // { component: <FAQSection faqItems={faqItemsForStartups} />, bgColor: "", id: "startup-FAQSection", isFlex1: true },

  // // Whatsapp
  // { component: <Whatsapp />, bgColor: "bg-[#ECECF7]", id: "whatsapp-Whatsapp" },
  // { component: <Keyfeatures />, bgColor: "", id: "whatsapp-Keyfeatures" },
  // { component: <HowItWorks />, bgColor: "bg-[#ECECF7]", id: "whatsapp-HowItWorks" },
  // { component: <AiExpertTutor />, bgColor: "", id: "whatsapp-AiExpertTutor" },
  // { component: <WhySchoolLoveAiPowred />, bgColor: "bg-[#ECECF7]", id: "whatsapp-WhySchoolLoveAiPowred" },
  // // { component: <FAQSection faqItems={faqItemsForWhatsapp} />, bgColor: "", id: "whatsapp-FAQSection", isFlex1: true },

  // // ID Card
  // { component: <IdCard />, bgColor: "bg-[#ECECF7]", id: "idcard-IdCard" },
  // { component: <IdCardHowItWorks />, bgColor: "", id: "idcard-IdCardHowItWorks" },
  // { component: <WhySchoolLoveAiPowredIdCard />, bgColor: "bg-[#ECECF7]", id: "idcard-WhySchoolLoveAiPowredIdCard" },
  // { component: <FAQSection faqItems={faqItemsForIdCards} />, bgColor: "", id: "idcard-FAQSection", isFlex1: true },

  // Webinar
  { component: <Webinar />, bgColor: "", id: "webinar-Webinar" },
  { component: <WhatYouWillLearn />, bgColor: "", id: "webinar-WhatYouWillLearn" },
  { component: <WhyYouShouldAttend />, bgColor: "bg-[#ECECF7]", id: "webinar-WhyYouShouldAttend" },
  { component: <WhoShouldAttend />, bgColor: "", id: "webinar-WhoShouldAttend" }
];

const NewLandingPage = () => {
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const type = searchParams.get('type');
  const sectionRefs = React.useRef([]); // Create refs

  useMemo(() => {
    if (location.hash) {
      const hash = location.hash.substring(1); // Remove the '#'

      // Find section that starts with the hash
      const targetSection = renderComponents.find(comp =>
        comp.id.startsWith(hash)
      );

      if (targetSection) {
        const index = renderComponents.indexOf(targetSection);

        // Small delay to ensure DOM is ready
        setTimeout(() => {
          const element = sectionRefs.current[index];
          if (element) {
            const elementPosition = element.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - 100;

            window.scrollTo({
              top: offsetPosition,
              // behavior: 'smooth'
            });
          }

          // Remove hash from URL after scrolling
          window.history.replaceState(null, '', window.location.pathname + window.location.search);
        }, 100);
      }
    }
  }, [location.hash]);

  if (type === '2') {
    return (
      <div className="bg-[#F6F7F9] container mx-auto font-poppins">
        <HeroSection />
        <AddOns />
        <AIBasedFeeCollection />
        <AIReelGenration />
        <AILearning />
        <AIChildCare />
        <ForStartups />
        <AIbasedContent />
        <AIBasedStudent />
        <Blog />
        <InNews />
        <SchoolMarketing />
        <AIBasedFestival />
        <AIBasedParental />
      </div>
    );
  } else if (type === "3") {
    return <div className="bg-[#FCFAFF]" style={{
      position: "relative",
      zIndex: 1,
      backgroundColor: "transparent",
    }}>
      <ParticlesBackground />
      <NewHeroSection />
    </div>
  }

  return <div className="bg-[#FCFAFF]" style={{
    position: "relative",
    zIndex: 1,
    // backgroundColor: "transparent",
  }}>
    {/* <ParticlesBackground /> */}
    <NewHeroSection
      renderComponents={renderComponents}
      sectionRefs={sectionRefs}
    />

    {/* Render sections with IDs and refs */}
    {renderComponents.map((element: any, index) => (
      <div
        key={"components" + index}
        id={element?.id}
        ref={(el) => (sectionRefs.current[index] = el) as any}
      >
        <LandingPageComponentWrapper bg={element?.bgColor} isFlex1={element?.isFlex1}>
          {element?.component}
        </LandingPageComponentWrapper>
      </div>
    ))}
    <Footer />
  </div>
}

export default NewLandingPage;